import { useEffect, useRef } from 'react';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { EmptyCalendarMessage } from '../../../components/empty-calendar-message';
import { OnboardingFlowInitiatorInline } from '../../../components/onboarding-flow-components/onboarding-flow-initiator-inline';
import { useOnboardingFlowInfo } from '../../../hooks/onboarding-flow-hooks/use-onboarding-flow-info';
import { useGetCalendarV3QueriesData } from '../../../hooks/scheduler-v3/use-get-calendar-v3-queries-data';

export const OnboardingFlowEmptyCalendarComponent = () => {
  const isSetupClickedRef = useRef(false);
  const { navigate, isOpen: isSettingsOpen } = useSettingsNavigate();
  const { calendarLocationIds } = useGetCalendarV3QueriesData();
  const {
    shouldShowOnboardingFlowInlineComponent,
    isBookAppointmentVisible,
    onboardingFlowInfo,
    setOnboardingFlowInfo,
    setShowOnNextLogin,
  } = useOnboardingFlowInfo();

  useEffect(() => {
    if (
      !isSettingsOpen &&
      !isBookAppointmentVisible &&
      onboardingFlowInfo.status === 'in_progress' &&
      isSetupClickedRef.current
    ) {
      // for setting panel close case, show onboarding flow on next login if user is still in in-progress onboarding flow
      setShowOnNextLogin();
    }
  }, [isSettingsOpen, isBookAppointmentVisible, onboardingFlowInfo.status, isSetupClickedRef.current]);

  const handleSetupClick = () => {
    isSetupClickedRef.current = true;
    navigate({ to: '/schedule', context: { shouldShowOnboardingFlow: true, calendarLocationIds } });
    setOnboardingFlowInfo({ status: 'in_progress' });
  };

  return shouldShowOnboardingFlowInlineComponent ? (
    <OnboardingFlowInitiatorInline onSetUpClick={handleSetupClick} />
  ) : (
    <EmptyCalendarMessage />
  );
};
